import { Component } from '@angular/core';

@Component({
  selector: 'app-policy',
  imports: [],
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss'],
  standalone: true
})

export class PolicyComponent {
  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }
}
